import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.array.some";
import { isString } from '../../utils/lang';
import { ENGINE_MATCHER_CONTAINS_STRING } from '../../logger/constants';
export function containsStringMatcherContext(log, ruleAttr) {
  return function containsStringMatcher(runtimeAttr) {
    var contains = ruleAttr.some(function (e) {
      return isString(runtimeAttr) && runtimeAttr.indexOf(e) > -1;
    });
    log.debug(ENGINE_MATCHER_CONTAINS_STRING, [runtimeAttr, ruleAttr, contains]);
    return contains;
  };
}